import { browserTracingIntegration } from "@sentry/browser";
import * as Sentry from "@sentry/react";

if (import.meta.env.VITE_WEBAPP_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_WEBAPP_SENTRY_DSN,
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/configuration/options/#sendDefaultPii
    sendDefaultPii: true,
    // Alternatively, use `process.env.npm_package_version` for a dynamic release version
    // if your build tool supports it.
    // release: import.meta.env.VITE_WEBAPP_SENTRY_RELEASE,
    integrations: [browserTracingIntegration()],
    tracesSampleRate: 1.0,
    environment: import.meta.env.VITE_ENVIRONMENT,
    normalizeDepth: 10,
  });
}

export const sentryCaptureException = (error: Error) => {
  if (import.meta.env.VITE_WEBAPP_SENTRY_DSN) {
    Sentry.captureException(error);
  }
};
